// extracted by mini-css-extract-plugin
module.exports = {"snackbarContainerRoot":"MainLayout_snackbarContainerRoot__0QyE6"};